import { render, staticRenderFns } from "./misCursosCard.vue?vue&type=template&id=2842c3e0&scoped=true"
import script from "./misCursosCard.vue?vue&type=script&lang=js"
export * from "./misCursosCard.vue?vue&type=script&lang=js"
import style0 from "./misCursosCard.vue?vue&type=style&index=0&id=2842c3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2842c3e0",
  null
  
)

export default component.exports